module.exports = __webpack_public_path__ + "img/kde-plasma-omgubuntu.png";